import React from "react";
export const SearchResultItem = ({ title, summary, url }) => React.createElement("article", { className: "search-result-item" },
    React.createElement("h4", { className: "search-result-item__title" },
        React.createElement("a", { className: "search-result-item__url", href: url }, title)),
    React.createElement("p", { className: "search-result-item__summary" }, summary));
